export default [
  {
    path: '/admin/defines/feature-groups',
    name: 'FeatureGroups',
    component: () => import('@/views/Admin/Defines/Feature_groups/Index.vue'),
    meta: {
      pageTitle: 'Özellik Grupları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/feature-groups/add',
    name: 'FeatureGroupAdd',
    component: () => import('@/views/Admin/Defines/Feature_groups/Add.vue'),
    meta: {
      pageTitle: 'Özellik Grupları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/feature-groups',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/feature-groups/edit/:id',
    name: 'FeatureGroupEdit',
    component: () => import('@/views/Admin/Defines/Feature_groups/Edit.vue'),
    meta: {
      pageTitle: 'Özellik Grupları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/feature-groups',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
